import { type EmptyLocation } from '../../domain/shipment/EmptyLocation'

export type RawEmptyLocation = {
  id: number
  shipment: string
  city: string
  state: string
  availability_date: Date
  zipcode?: string
  timezone?: string
}

export function mapApiToEmptyLocation(rawEmptyLocation: RawEmptyLocation): EmptyLocation {
  const emptyLocation: EmptyLocation = {
    id: rawEmptyLocation.id,
    shipment: rawEmptyLocation.shipment,
    city: rawEmptyLocation.city,
    state: rawEmptyLocation.state,
    availabilityDate: rawEmptyLocation.availability_date,
    zipcode: rawEmptyLocation.zipcode,
    timezone: rawEmptyLocation.timezone,
  }
  return emptyLocation
}
